import debug from 'debug'

export const debugAuth = debug('auth')
export const debugExtendedAccess = debugAuth.extend('extended-access')
